import React, { useContext } from 'react'
import { UserContext } from '../../context/userAuth'
import Login from '../Login/Login';
import { Navigate } from 'react-router-dom';
import { paths } from '../../utils/routes';

export default function ProtectedRoute({ children }) {
    const { userToken } = useContext(UserContext);
    if (localStorage.getItem('userToken')) {
        return children;
    } else {
        return <>
            <Navigate to={paths.login} />
        </>
    }
}
